import { Drawer, Box, Grid } from "@mui/material";
import { Laptop, List, ShowChart, Group } from "@mui/icons-material";
import routes from "../../../routes";
import { CohereLogo } from "@coherehealth/common";
import { useAuthorized } from "../../../Authorization";
import { QueueViewState } from "@coherehealth/qm-api";
import { useQmNavigationStyles } from "./qmNavigationStyles";
import { NavItem } from "./NavItem";
import { LogoutItem } from "./LogoutItem";
interface LeftNavbarProps {
  drawerWidth: number;
  queueViewState: QueueViewState;
}
export const LeftNavBar = ({ drawerWidth, queueViewState }: LeftNavbarProps) => {
  const isQMSupervisor = useAuthorized("SUPERVISOR");
  const isQMManager = useAuthorized("QM_MANAGER");
  const classes = useQmNavigationStyles({ drawerWidth });
  return (
    <Box component="nav" className={classes.navContainer}>
      <Drawer variant="permanent" anchor="left">
        <Grid container style={{ width: drawerWidth, display: "flex" }}>
          <Box display="flex" justifyContent="center" mt={2} mb={4} width="100%">
            <CohereLogo height={25} width={50} />
          </Box>
          {queueViewState === "NO_QUEUE" ? (
            <Box position="absolute" left="20px" bottom="24px">
              <LogoutItem queueViewState={queueViewState} />
            </Box>
          ) : (
            <>
              <Box className={classes.navItemContainer}>
                <NavItem testid="qm-nav-my-work" to={routes.DASHBOARD} label="My work" Icon={Laptop} />
              </Box>
              {isQMSupervisor && (
                <>
                  <Box className={classes.navItemContainer}>
                    <NavItem testid="qm-nav-queues" to={routes.SUPERVISOR_DASHBOARD} label="Queues" Icon={List} />
                  </Box>
                  <Box className={classes.navItemContainer}>
                    <NavItem testid="qm-nav-reports" to={routes.REPORTS.DASHBOARD} label="Reports" Icon={ShowChart} />
                  </Box>
                  {isQMManager && (
                    <Box className={classes.navItemContainer}>
                      <NavItem testid="qm-nav-users" to={routes.USER_MANAGEMENT} label="Users" Icon={Group} />
                    </Box>
                  )}
                </>
              )}
              <Box position="absolute" left="20px" bottom="24px">
                <LogoutItem queueViewState={queueViewState} />
              </Box>
            </>
          )}
        </Grid>
      </Drawer>
    </Box>
  );
};
